<template>
  <v-card style="width: 100%" class="pa-4">
    <div class="d-flex pb-4">
      <h3 style="flex: 1">{{ title }}</h3>
      <h4 class="mr-6">{{ indicator }}</h4>
    </div>
    <div style="max-height: 350px; height: 350px; overflow-y: auto">
      <div v-if="data && data.length">
        <div
          v-for="row in data"
          :key="row.id"
          class="d-flex pb-1"
          style="align-items: center"
        >
          <span style="flex: 1">{{ row.x }}</span>
          <span style="display: flex; align-items: center"
            >{{ row.y }}
            <span class="ratio ml-2">
              <span
                class="bg"
                :style="{
                  width: (row.ratio * 60) / 100 + 'px',
                }"
              >
              </span>
              <span class="number">{{ row.ratio }}%</span></span
            ></span
          >
        </div>
      </div>
      <div
        v-else
        style="color: rgb(155, 151, 151); text-align: center"
        class="mt-2"
      >
        No data found
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: ["title", "indicator", "data", "nameProp"],
};
</script>

<style lang="scss" scoped>
.ratio {
  width: 60px;
  display: block;
  position: relative;
  transition: width 300ms;

  .bg {
    background-color: #eaf2fc;
    height: 22px;
    display: block;
    border-left: 1px solid #cccccc;
  }

  .number {
    color: #444444;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 12px;
  }
}
</style>